import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_DETERMINING } from '../../../analytics/Sources';
import { getErrorDetails } from '../../../utils/request-utils';
import CancelButton from './common/CancelButton';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveDialogDetermining = _ref => {
  let {
    closeInstallDialog,
    determiningInstallMode,
    hostConfig,
    featureFlags
  } = _ref;
  return {
    analyticsSourceModal: ANALYTICS_MODAL_DETERMINING,
    content: null,
    heading: determiningInstallMode.error ? 'Error' : 'Loading...',
    footerRight: /*#__PURE__*/_jsx(CancelButton, {
      isDisabled: false,
      onClick: closeInstallDialog,
      children: "Cancel"
    }),
    preventDialogClosing: false,
    errorDetails: determiningInstallMode.error ? Option.some(getErrorDetails(determiningInstallMode.error, hostConfig, {
      showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
    })) : Option.none()
  };
};
export default resolveDialogDetermining;